/* eslint-disable @next/next/no-img-element */
import HeadingServices from '../HeadingServices';
import Paragraf from '../Paragraf';


export default function EfficencyAnalysis({ datasEfficency }) {

    return (
        <div >
            <HeadingServices title={datasEfficency.upperTitle} lowerTitle={datasEfficency.documentTitle}/>
            <div className="container my-3 my-lg-5">
                <div className="row">
                    <div className="col">
                        <div className="float-right img-small-width img-fluid pl-md-3 mb-md-2">
                            <img
                                width="100%"
                                height="100%"
                                src="/images/it/efficiency_new.png"
                                alt="layout styles" />
                        </div>
                        <Paragraf parag={datasEfficency.pOne} />
                        <Paragraf parag={datasEfficency.pTwo} />
                    </div>
                </div>
            </div>
        </div>
    )
}
